/**
 * Created by chenzheyu on 2017/6/24.
 */
import Vue from 'vue'
import InitData from '../../store/configure'
import WX from 'weixin-js-sdk'
import JSONBig from 'json-bigint-xk'
// callback(data.body)

export default {
  makeAnAppointment (obj, callback) { // 下单
    var params = {
      'app_key': InitData.appKey,
      'ack': InitData.acKey ? InitData.acKey : null,
      'passengerId': obj.passengerId,
      'passengerName': obj.passengerName,
      'passengerPhone': obj.passengerPhone,
      'companyId': obj.companyId,
      'channelName': obj.channelName,
      'couponId': obj.couponId,
      'serverTime': obj.serverTime,
      'budgetPay': obj.budgetPay,
      'startAddress': obj.startAddress,
      'startLat': obj.startLat,
      'startLng': obj.startLng,
      'userPhone': obj.userPhone,
      'endAddress': obj.endAddress,
      'endLat': obj.endLat,
      'endLng': obj.endLng,
      'openId': obj.openId
    }
    var url = InitData.weixinUrl + '/api/daijia/create'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  queryOrder (obj, callback) { // 查询单个订单
    var params = {
      'app_key': InitData.appKey,
      'passengerId ': obj.passengerId
    }
    var url = InitData.serverUrl + '/h5/v4/dj/getRunning'
    Vue.http.get(url, params).then(
      data => {
        callback(data.body, obj.type)
      }
    )
  },

  budgetCost (params, callback) { // 获取预算费用
    params = Vue.prototype.$utils.objKeySort('/passenger/api/v1/getBudgetPrice', params)
    var url = 'v1/getBudgetPrice'
    Vue.http.get(url, {params}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  coupon (obj, callback) { // 获取 优惠券
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId
    }
    var url = InitData.weixinUrl + '/h5/v4/dj/findCouponV4'
    Vue.http.get(url, {params}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  cancelOrder (obj, callback) { // 取消优惠券
    var params = {
      'app_key': InitData.appKey,
      'orderId': obj.orderId,
      'reson': obj.reson
    }
    var url = InitData.weixinUrl + '/h5/v4/dj/cancelOrder'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  balancePay (obj, callback) { // 余额签单支付
    var params = {
      'app_key': InitData.appKey,
      'orderId': obj.orderId,
      'who': obj.who,
      'payType': obj.payType
    }
    var url = InitData.weixinUrl + '/h5/v4/dj/doPay'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  payInfo (obj, callback) { // 余额签单支付
    var params = {
      'app_key': InitData.appKey,
      'orderId': obj.orderId
    }
    var url = InitData.weixinUrl + '/h5/v4/dj/prepay'
    Vue.http.get(url, {params}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  weixinPay (obj, callback) { // 微信支付
    var params = {
      'app_key': InitData.appKey,
      'orderId': obj.orderId,
      'openId': obj.openid,
      'appId': obj.WXappId
    }
    var url = InitData.weixinUrl + '/v5/daijia/doPayForWx'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => {
        if (data.body.code === 0) {
          var content = data.body.data

          WX.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: window.configure.WXappId, // 必填，公众号的唯一标识
            timeStamp: content.timestamp, // 必填，生成签名的时间戳
            nonceStr: content.nonceStr, // 必填，生成签名的随机串
            signature: content.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })

          WX.ready(function () {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            WX.chooseWXPay({
              timestamp: content.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: content.nonceStr, // 支付签名随机串，不长于 32 位
              package: content.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
              signType: 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: content.paySign, // 支付签名
              success: function (res) {
                // 支付成功后的回调函数
                callback('支付成功')
              }
            })
          })
          WX.error(function (res) {
            callback('支付失败')
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          })
        }
      }
    )
  },
  evaluateOrder (obj, callback) { // 评价
    var params = {
      'app_key': InitData.appKey,
      'orderId': obj.orderId,
      'phone': obj.phone,
      'score': obj.score,
      'content': obj.content,
      'driverId': obj.driverId
    }
    var url = InitData.weixinUrl + '/api/daijia/review'
    Vue.http.post(url, params, {emulateJSON: true}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  },
  queryReview (obj, callback) { // 获取评价
    var params = {
      'app_key': InitData.appKey,
      'passengerId': obj.passengerId,
      'orderId': obj.orderId
    }
    var url = InitData.weixinUrl + '/v5/daijia/getReview'
    Vue.http.get(url, {params}).then(
      data => {
        callback(JSONBig.parse(data.bodyText))
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/daijia/daijia.js